export interface DomainConfig {
  domain: string;
  name: string;
  logo?: {
    header?: string;
    content?: string;
  };
  translations?: {
    [locale: string]: {
      [key: string]: any;
    };
  };
}

export const domainConfigs: DomainConfig[] = [
  {
    domain: "localhost",
    name: "Localhost Development",
    logo: {
      header: "/logos/localhost-header.svg",
      content: "/logos/localhost-content.svg",
    },
    translations: {
      en: {
        "header.title": "Localhost Tenant Portal",
        "welcome.message": "Welcome to the Development Portal",
      },
      es: {
        "header.title": "Portal de Inquilinos Localhost",
        "welcome.message": "Bienvenido al Portal de Desarrollo",
      },
    },
  },
  {
    domain: "app.mylighthouse.co",
    name: "My Lighthouse",
    logo: {
      header: "/logos/mylighthouse-header.png",
      content: "/logos/mylighthouse-content.png",
    },
    translations: {
      en: {
        "header.title": "My Lighthouse Tenant Portal",
        "welcome.message": "Welcome to My Lighthouse",
        "company.name": "My Lighthouse Insurance",
      },
      es: {
        "header.title": "Portal de Inquilinos My Lighthouse",
        "welcome.message": "Bienvenido a My Lighthouse",
        "company.name": "My Lighthouse Insurance",
      },
    },
  },
];

export const getConfigByDomain = (hostname: string): DomainConfig | null => {
  console.log('Checking domain config for hostname:', hostname);
  
  const config = domainConfigs.find(config => {
    const matches = hostname === config.domain;
    console.log(`Domain ${config.domain} matches ${hostname}:`, matches);
    return matches;
  });
  
  console.log('Selected config:', config);
  return config || null;
};

export const getCurrentDomainConfig = (): DomainConfig | null => {
  if (typeof window === 'undefined') return null;
  return getConfigByDomain(window.location.hostname);
};